module.exports = __webpack_public_path__ + "img/ruanzhu1818.3e49301f.png";